import { useEffect, useRef, useState } from "react";
import { IPersona } from "../../../Interfaces/IPersona";
import { ISearchBox } from "@fluentui/react";
import personaServicio from "../../../services/persona/personaServicio";
import { IOperador, IOperadorRequest } from "../../../Interfaces/auxiliar/IOperador";
import { IPaginationV2 } from "../../../Interfaces/base/ITable";



export type keyType = "turnoKey" | "razonKey" | "ubicacionKey" | "equipoKey"
export type textType = "tuernoText" | "razonText" | "ubicacionText" | "equipoText"


export interface IFilter2 {
    turnoKey: string,
    tuernoText: string
    razonKey: string,
    razonText: string
    ubicacionKey: string,
    ubicacionText: string
    equipoKey: string,
    equipoText: string
}

const initialFilter2: IFilter2 = {
    turnoKey: "",
    tuernoText: "",
    razonKey: "",
    razonText: "",
    ubicacionKey: "",
    ubicacionText: "",
    equipoKey: "",
    equipoText: ""
}

const UseOperador = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [items, setItems] = useState<IOperador[]>([]);
  const onChangeSearch = useRef<ISearchBox>(null);
  const [filter, setFilter] = useState<IOperadorRequest>({
    skip: 0,
    take: 50,
    search: "",
    isClaveEnrolar: true
  });

  const initial: IOperadorRequest = {
    skip: 0,
    take: 50,
    search: "",
    isClaveEnrolar: true
  };

  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

const onChangeTake = (value: number) => {
    setFilter({ ...filter, take: value })
};
const onSkip = (value: number) => {
    const realSkip = (value * filter.take) - filter.take
    setFilter({ ...filter, skip: realSkip })
};

const [pagination, setPagination] = useState<IPaginationV2>({
  currentPage: 0,
  total: 0,
  pageSize: 0,
  skip: 0,
  take: 50,
  onPageChange: function (value: number): void {
  },
  onSizeChange: function (value: number): void {
  }
})
  const handleResetUpdate = () => {
    setFilter(initial);
  };

  const getOperador = () => {
    setLoading(true);
    personaServicio.tablaPersona(filter)
      .then((res) => {
        const pag: IPaginationV2 = {
          currentPage: res.data.page,
          total: res.data.total,
          pageSize: res.data.pages,
          onPageChange: onSkip,
          skip: filter.skip,
          take: filter.take,
          onSizeChange: onChangeTake
      };
        setPagination(pag);
        setLoading(false);
        const transformedData: IOperador[] = res.data.data.map((item: IPersona) => ({
          personaId: item.personaId,
          apellidoPaterno: item.apellidoPaterno,
          apellidoMaterno: item.apellidoMaterno,
          primerNombre: item.primerNombre,
          segundoNombre: item.segundoNombre,
          codigoSync: item.codigoSync,
          operador: item.claveEnrolar,
          codigoRRHH: item.codigoRRHH,
          nombreCompleto: `${item.primerNombre ?? ""} ${item.segundoNombre ?? ""}`,
          apellidoCompleto: `${item.apellidoPaterno ?? ""} ${item.apellidoMaterno ?? ""}`,
          estado: item.estado,
          nroDOI:item.nroDOI
        }))
        setItems(transformedData);
      })
      .catch((e: any) => {
        setLoading(false);
      });
  };


  useEffect(() => {
    if (filter) {
      getOperador();
    }
  }, [filter]);

  return {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    handleResetUpdate,
    onChangeSearch,
    onChangeTake,
    _onkeyUpSearchTable
  }
}

export { UseOperador }